import type { QuillOptions } from 'quill';
import { Delta } from 'quill/core.js';

const clipBoardMatcher = (node, delta) => {
  return delta.compose(
    new Delta().retain(delta.length(), {
      color: '',
      background: '',
      header: 0,
    }),
  );
};

export const getQuillOptions = (): QuillOptions => {
  return {
    readOnly: false,
    modules: {
      clipboard: {
        matchers: [['*', clipBoardMatcher]],
      },
      toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ background: [] }],
        [{ script: 'super' }, { script: 'sub' }],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link', 'formula'],
        ['clean'],
      ],
    },
    theme: 'snow',
  };
};
